import { useEffect, useRef } from "react"
import { Thread, ConversationItems } from "../../../../types"
import ThreadItem from "../thread-item"

interface Props {
  conversation: ConversationItems
  thread: Thread
  onResize: () => void
}

const ThreadItemList = ({ conversation, thread, onResize }: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  // Use ResizeObserver to observe changes in the container's size (e.g., image loading)
  useEffect(() => {
    const scrollContainer = wrapperRef.current
    const observer = new ResizeObserver(() => {
      onResize()
    })

    if (scrollContainer) {
      observer.observe(scrollContainer)
    }

    return () => {
      if (scrollContainer) {
        observer.unobserve(scrollContainer)
      }
    }
  }, [onResize])

  return (
    <div
      ref={wrapperRef}
      className="px-4 md:px-8 py-4 flex flex-col lg:max-w-[800px] lg:mx-auto"
    >
      {conversation.map((item, index) => (
        <ThreadItem
          conversation={conversation}
          key={item._id}
          item={item}
          thread={thread}
          index={index}
        />
      ))}
    </div>
  )
}

export default ThreadItemList
